import { useAppSelector } from '@/hooks'

/**
 * Whether Profiles renders its Box Truck presentation for this account.
 *
 * Two grants, one answer. Settings → Team's per-member checkbox comes back on the signed-in user from
 * `/auth/verify` (`user.boxTruckAccess`), so it is read here and applies on the first render with no request. The second is the ACCOUNTANT role on a
 * box-truck company — that company test is the Gluon owner allowlist, which the client never sees, so the
 * server answers it on the access request the layout already makes (`useBoxTruckLoadsOperator`), seeded
 * from the last confirmed answer so a returning accountant does not watch the page change shape.
 *
 * Box Truck workspace/menu access remains owned by the Gluon operator allowlist, separately.
 */
export const useBoxTruckProfilesMode = (): boolean =>
    useAppSelector((state) => {
        if (state.boxTruckLoads.profilesFromRole) return true
        // Kept as a synchronous read rather than folded into the server answer: it is what makes the box
        // truck presentation render on the first paint for the members who already had it.
        return state.auth.user?.boxTruckAccess === true
    })
